<template>
  <div class="webgl-legend white bg-secondary rounded p-3">
    <ul class="p-0">
      <li>
        <div class="indicator border-1" :style="style('holes')" />
        {{ $t('BoardInspectorLegend.npth') }}
      </li>
      <li>
        <div class="indicator border-1" :style="style('millinglv1')" />
        {{ $t('BoardInspectorLegend.milling') }}
      </li>
      <li>
        <div class="indicator border-1" :style="style('board')" />
        {{ $t('BoardInspectorLegend.base_material') }}
      </li>
    </ul>
  </div>
</template>

<script>
import PcbMaterials from 'helper/pcb_materials';
import messages from 'locales/BoardInspectorLegend';

export default {
  name: 'BoardInspectorLegend',
  props: {
    materialPreset: String,
  },
  computed: {
    materialColors() {
      return PcbMaterials[this.materialPreset];
    },
  },
  methods: {
    style(material) {
      return {
        'background-color': this.materialColors[material].color.getStyle(),
      };
    },
  },
  i18n: { messages },
};
</script>

<style scoped lang="scss">
</style>
